// @ts-nocheck
import StoreAnchorLink, { StoreAnchorProps } from "@store/Library/Components/Foundation/StoreAnchorLink";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { LinkProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

export interface StoreAnchorMenuProps {
    links: Array<StoreAnchorProps>;
}

export interface StoreAnchorMenuStyles {
    anchorsMenu: InjectableCss;
    anchorsMenuLink: LinkProps;
}

const hoverBorderWidth = pxToRem(5);

const styles = {
    anchorsMenu: {
        css: css`
            display: flex;
            width: 100%;
            background-color: ${getColor("common.accentLighter")};
            justify-content: center;
            padding: 0 1.25em;
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};

            ${breakpointValues([null, null, null, "0 2.5em"], "padding")}
            ${breakpointValues(["none", null, "flex"], "display")}
        `,
    },
    anchorsMenuLink: {
        css: css`
            padding: calc(1.25em - ${hoverBorderWidth}) 0;
            color: ${getColor("primary")};
            text-align: center;
            border-bottom: ${hoverBorderWidth} solid transparent;
            border-top: ${hoverBorderWidth} solid transparent;
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};

            ${transitionHoverStyles()}
            ${contentSpacingStyles(0, "8.5em", 0, 0)}

            &:hover {
                border-bottom-color: ${getColor("common.borderColored")};
            }
        `,
    },
};

const StoreAnchorMenu: React.FC<StoreAnchorMenuProps> = ({ links }) => {
    return (
        <StyledWrapper {...anchorStyles.anchorsMenu}>
            {links.map((link: StoreAnchorProps) => {
                return <StoreAnchorLink key={link.fields.linkTitle} {...link} {...anchorStyles.anchorsMenuLink} />;
            })}
        </StyledWrapper>
    );
};

export const anchorStyles = styles;
export default StoreAnchorMenu;
